document.addEventListener('DOMContentLoaded', function() {
  // Appliquer sur les pages produit et panier
  var inputs = document.querySelectorAll('input[name="quantity"]');
  inputs.forEach(function(input) {
    // Toujours forcer la valeur à 1
    input.value = 1;
    // Empêcher de changer
    input.setAttribute('min', '1');
    input.setAttribute('max', '1');
    input.addEventListener('change', function() {
      if (this.value !== '1') this.value = '1';
    });
  });
});